import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { getVolumes, updateVolume } from '../../../../entity/volumes/Volumes'
import { MdOutlineModeEdit } from 'react-icons/md'
import CreateVolumeModal from '../../../../components/CreateVolumeModal/CreateVolumeModal'

const EditVolume = ({ volumeId, data }) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)

  const editVolumeModalHandler = () => {
    setIsOpen(prev => !prev)
  }

  const onEditVolumeSubmit = async values => {
    if (values && volumeId) {
      await dispatch(updateVolume({ volumeId: volumeId, volumeData: values }))
      dispatch(getVolumes())
      editVolumeModalHandler()
    }
  }

  return (
    <>
      <MdOutlineModeEdit
        className='hover:cursor-pointer hover:scale-110 transition-all'
        onClick={editVolumeModalHandler}
      />
      {data && isOpen && (
        <CreateVolumeModal
          isOpen={isOpen}
          onClose={editVolumeModalHandler}
          data={data || {}}
          onSubmit={onEditVolumeSubmit}
        />
      )}
    </>
  )
}

export default EditVolume
